import { supabase } from '@/utils/supabase';

// Map DB description → app category key
const descToCategory = {
  '3D Product': '3d_products',
  'Apparel': 'apparel',
};

// Map app category key → DB description
const categoryToDesc = {
  '3d_products': '3D Product',
  'apparel': 'Apparel',
};

// Extra carousel images for products that have multiple angles in /public
const PRODUCT_IMAGES = {
  'Modern Bugatti Concept': [
    '/3.4view.png',
    '/frontview.png',
    '/topview.png',
    '/3stageview.png',
    '/bugattimodel.png',
  ],
  'Modern Lotus Concept': [
    '/lotus3d.png',
  ],
  'Black Designer Crew Neck Sweater': [
    '/blackcrew.png',
  ],
  'Designer T-Shirt': [
    '/anonymousTshirt.png',
  ],
};

// Background color for image containers — matches the image's own background for a seamless look
const PRODUCT_BG_COLORS = {
  'Modern Bugatti Concept': '#050505',
  'Modern Lotus Concept': '#acacac',
};

// Total limited-run inventory per product (used to display "X left out of N")
const PRODUCT_MAX_INVENTORY = {
  'Modern Bugatti Concept': 30,
  'Modern Lotus Concept': 30,
};

// Per-size inventory counts. null = unlimited/unavailable, 0 = out of stock.
const PRODUCT_SIZE_INVENTORY = {
  'Designer T-Shirt': { S: 0, M: 4, XL: 1, XXL: 5 },
  'Black Designer Crew Neck Sweater': { S: 7, M: 2 },
  'Grey Hoodie': { S: 0, M: 0, L: 1, XL: 0, XXL: 0 },
  'Tan Hoodie': { S: 0, M: 2, L: 0, XL: 0, XXL: 0 },
  'Premium Black Hoodie': { S: 0, M: 4, L: 3, XL: 0, XXL: 0 },
};

function mapProduct(row) {
  const images = PRODUCT_IMAGES[row.name] || (row.image_url ? [row.image_url] : []);
  const bgColor = PRODUCT_BG_COLORS[row.name] || null;
  const maxInventory = PRODUCT_MAX_INVENTORY[row.name] || null;
  const sizeInventory = PRODUCT_SIZE_INVENTORY[row.name] || null;
  const sizes = sizeInventory ? Object.keys(sizeInventory) : null;
  return {
    id: row.id,
    name: row.name,
    price: row.price / 100,
    category: descToCategory[row.description] || row.description,
    featured: true,
    images,
    bgColor,
    maxInventory,
    sizeInventory,
    sizes,
    stripe_price_id: row.stripe_price_id,
    inventory: row.inventory,
  };
}

export const Product = {
  filter: async ({ category, featured } = {}, sort = '-created_date', limit = 4) => {
    let query = supabase
      .from('products')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);

    if (category && categoryToDesc[category]) {
      query = query.eq('description', categoryToDesc[category]);
    }

    const { data, error } = await query;
    if (error) throw error;
    return (data || []).map(mapProduct);
  },

  getById: async (id) => {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('id', id)
      .single();
    if (error) return null;
    return mapProduct(data);
  },
};

